module.exports = __webpack_public_path__ + "img/print.b08413b8.png";